import React, { useEffect, useState } from "react";
import { useParams } from "react-router";

import axios from "axios";
import AchievementsCard from "../../../components/cards/AchievementsCard";
import ProfileBanner from "../../../components/sections/ProfileBanner";
import { serverUrl } from "../../../nestserver";
import medal from "../../../resources/medal01.svg";

function DynamicProfile() {
  const { userId } = useParams();

  const [profileData, setProfileData] = useState({});

  useEffect(() => {
    axios({
      method: "get",
      url: serverUrl + "/users/" + userId,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    })
      .then((res) => {
        setProfileData(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  const roleKey =
    profileData?.role === "instructor" ? "teacher" : profileData?.role;
  const roleData = profileData?.[roleKey];

  return (
    <div>
      <div className="h-full p-10 ">
        <ProfileBanner
          readOnly
          userId={profileData?._id}
          roleData={roleData}
          subtitle={profileData?.username}
        />

        <div className="pt-10">
          <div>
            <div className="flex-grow bg-white rounded-xl pb-8  relative ">
              <div className="p-5 ">
                <div className="text-2xl font-medium text-black text-left px-5">
                  Achievements
                </div>
                <div className="flex flex-col space-y-2 divide-y">
                  {roleData?.achievements ? (
                    roleData.achievements.map((item) => (
                      <AchievementsCard
                        image={medal}
                        title={item.title}
                        content={item.description}
                      />
                    ))
                  ) : (
                    <div className="flex items-center justify-center py-6 ">
                      <div className="text-xl font-light ">
                        No Achievements To Show
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DynamicProfile;
